import React from 'react';
import './StatusBanner.css';

const STATUS_CONFIG = {
  'error-message': {
    modifier: 'error',
    icon: 'fa-exclamation-circle',
    label: 'Error',
  },
  'success-message': {
    modifier: 'success',
    icon: 'fa-check-circle',
    label: 'Success',
  },
  'nudge-message': {
    modifier: 'nudge',
    icon: null,
    label: 'Notice',
  },
};

export function getStatusBannerModifier(status) {
  return STATUS_CONFIG[status]?.modifier || 'error';
}

export default function StatusBanner({ status, message, onDismiss }) {
  const config = STATUS_CONFIG[status] || STATUS_CONFIG['error-message'];
  const isNudge = status === 'nudge-message';

  return (
    <div
      className={`status-banner status-banner--${config.modifier}`}
      role="alert"
      aria-live="polite"
    >
      <div className="status-banner-inner">
        {!isNudge && (
          <div className="status-banner-icon" aria-hidden="true">
            <i className={`fas ${config.icon}`} />
          </div>
        )}
        <div className="status-banner-content">{message}</div>
        <button
          type="button"
          className="status-banner-dismiss"
          onClick={onDismiss}
          aria-label="Dismiss message"
        >
          <i className="fas fa-times" />
        </button>
      </div>
    </div>
  );
}
